import Gallery from './Gallery';
import Hero from './Hero';

const HomeV2 = () => {
  return (
    <>
      <Hero />
      <Gallery />
    </>
  );
};

export default HomeV2;
